import * as t from 'ts-codec';
import { ObjectId } from '@journeyapps-labs/micro-codecs';
export var ResourceType;
(function (ResourceType) {
    ResourceType["PROFILE"] = "profile";
    ResourceType["IMAGE"] = "image";
    ResourceType["PACK"] = "pack";
    ResourceType["GROUP"] = "group";
})(ResourceType || (ResourceType = {}));
export const ResourceImages = t.object({
    image_id: ObjectId.optional(),
    image_url: t.string.optional(),
    header_image_id: ObjectId.optional(),
    header_image_url: t.string.optional()
});
